import { render, staticRenderFns } from "./SecuredBy.vue?vue&type=template&id=172d853c&scoped=true&"
import script from "./SecuredBy.vue?vue&type=script&lang=js&"
export * from "./SecuredBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172d853c",
  null
  
)

export default component.exports